import React from 'react';
import { FormControl, Table, TableBody, TableHead, TableRow, TextField } from '@material-ui/core';

import {
    BodyTableCell,
    ContainerDiv,
    FlexSpaceBetweenDiv,
    HeaderTableCell,
    OverflowXDiv,
    SecondaryTextButton
} from '../components/components';
import { StringService } from '../utils/stringService';
import { TableFooterWithPaginator } from '../components/tableFooterWithPaginator';
import { SortHeaderCell } from '../components/sortHeaderCell';
import { withSnackbar } from 'notistack';
import { UserCompanyGroupService } from './userCompanyGroupService';
import { CollectionViewUpdater } from '../utils/collectionViewUpdater';
import { LoggedUserService } from '../loggedUser/loggedUserService';
import Spinner from 'react-spinner-material';
import { PageWrap, Card, CardHead, CardBody, PageBanner, CountBadge } from '../components/pageLayout';
import { Building2 } from 'lucide-react';

class UserCompanyGroupPage extends React.Component {
    constructor(props) {
        super(props);

        this.collectionUpdater = CollectionViewUpdater.ofCompanyGroups(this);

        this.state = {
            isLoading: false,
            filterQuery: '',
            collection: this.collectionUpdater.collection
        };
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        LoggedUserService.getLoggedUser().then(loggedUser => {
            this.setState({ loggedUser });

            UserCompanyGroupService.list(loggedUser.email).then(items => {
                this.collectionUpdater.initialData(items);
                this.setState({ isLoading: false });
            });
        });
    }

    changeCompanyGroupCompany = (companyGroup, companyId, companyName) => {
        const { onUpdate, enqueueSnackbar } = this.props;

        LoggedUserService.changeCompanyGroupCompany(companyGroup, companyId).then(() => {
            onUpdate(companyGroup);
            enqueueSnackbar(`Usuário alterado para ${companyGroup} - ${companyName}`);
        });
    };

    buildList = () => {
        const { isLoading, collection } = this.state;
        const { currentLanguage } = this.props;

        if (isLoading) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={2}>
                        <Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} />
                    </BodyTableCell>
                </TableRow>
            );
        }

        const items = collection.paginator.pagedItems;

        if (items.length === 0) {
            return (
                <TableRow>
                    <BodyTableCell colSpan={2}>{currentLanguage.empty_list}</BodyTableCell>
                </TableRow>
            );
        }

        return items.map(companyGroup => (
            <TableRow key={companyGroup.name}>
                <BodyTableCell>{companyGroup.name}</BodyTableCell>
                <BodyTableCell>
                    {companyGroup.companies.map(company => (
                        <SecondaryTextButton
                            key={company.id}
                            onClick={() =>
                                this.changeCompanyGroupCompany(companyGroup.name, company.id, company.name)
                            }
                        >
                            {company.name}
                        </SecondaryTextButton>
                    ))}
                </BodyTableCell>
            </TableRow>
        ));
    };

    render() {
        const { collection, filterQuery } = this.state;
        const { currentLanguage } = this.props;
        const { updateCollection, handleFilterChange, handleSort } = this.collectionUpdater;
        const pageItems = collection.paginator.pagedItems;

        const fieldLabelStyle = { fontSize: '0.75rem', fontWeight: 600, color: '#334155', marginBottom: 4 };

        return (
            <PageWrap>
                <PageBanner
                    icon={Building2}
                    title={currentLanguage.userCompanies}
                />

                <Card>
                    <CardHead>Filtros</CardHead>
                    <CardBody>
                    {/* Buscar */}
                    <div>
                        <div style={fieldLabelStyle}>{currentLanguage.search}</div>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            helperText={currentLanguage.company_group_database_name}
                            value={filterQuery}
                            onChange={event =>
                                handleFilterChange({ filterQuery: StringService.normalize(event.target.value) })
                            }
                        />
                    </div>
                    </CardBody>
                </Card>

                <Card>
                    <CardHead>{currentLanguage.userCompanies} <CountBadge>{pageItems.length}</CountBadge></CardHead>
                    <OverflowXDiv>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <SortHeaderCell
                                    sorter={collection.sorter}
                                    onSort={handleSort}
                                    field="name"
                                    width="8rem"
                                >
                                    {currentLanguage.company_group_database_name}
                                </SortHeaderCell>
                                <HeaderTableCell>{currentLanguage.select_company}</HeaderTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{this.buildList()}</TableBody>
                        <TableFooterWithPaginator
                            collection={collection}
                            onCollectionUpdate={updateCollection}
                            colSpan={8}
                        />
                    </Table>
                    </OverflowXDiv>
                </Card>
            </PageWrap>
        );
    }
}

export default withSnackbar(UserCompanyGroupPage);